import { render, staticRenderFns } from "./NewClientsTabTable.vue?vue&type=template&id=50203ac6"
import script from "./NewClientsTabTable.vue?vue&type=script&lang=js"
export * from "./NewClientsTabTable.vue?vue&type=script&lang=js"
import style0 from "./NewClientsTabTable.vue?vue&type=style&index=0&id=50203ac6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports